import React from 'react';
import { GameProvider } from './contexts/GameContext';
import Battlefield from './components/Battlefield';
import GameControls from './components/GameControls';
import UnitSelector from './components/UnitSelector';
import GameBanner from './components/GameBanner';

function App() {
  return (
    <GameProvider>
      <div className="app min-h-screen bg-gray-900 flex flex-col">
        <GameControls />
        
        <div className="flex-1 flex flex-col items-center justify-center relative overflow-hidden p-4">
          <div className="relative w-full max-w-6xl mx-auto">
            <Battlefield />
            <UnitSelector />
            <GameBanner />
          </div>
        </div>
      </div>
    </GameProvider>
  );
}

export default App;